/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type GetRiskPolicySecurityOption1 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type GetRiskPolicySecurityOption2 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type GetRiskPolicySecurity = {
  option1?: GetRiskPolicySecurityOption1 | undefined;
  option2?: GetRiskPolicySecurityOption2 | undefined;
};

export type GetRiskPolicyRequest = {
  /**
   * The policy ID.
   */
  id: string;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
};

/** @internal */
export type GetRiskPolicySecurityOption1$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const GetRiskPolicySecurityOption1$outboundSchema: z.ZodMiniType<
  GetRiskPolicySecurityOption1$Outbound,
  GetRiskPolicySecurityOption1
> = z.pipe(
  z.object({
    apikeyHeaderGramKey: z.string(),
    projectSlugHeaderGramProject: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
    });
  }),
);

export function getRiskPolicySecurityOption1ToJSON(
  getRiskPolicySecurityOption1: GetRiskPolicySecurityOption1,
): string {
  return JSON.stringify(
    GetRiskPolicySecurityOption1$outboundSchema.parse(
      getRiskPolicySecurityOption1,
    ),
  );
}

/** @internal */
export type GetRiskPolicySecurityOption2$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const GetRiskPolicySecurityOption2$outboundSchema: z.ZodMiniType<
  GetRiskPolicySecurityOption2$Outbound,
  GetRiskPolicySecurityOption2
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.string(),
    sessionHeaderGramSession: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function getRiskPolicySecurityOption2ToJSON(
  getRiskPolicySecurityOption2: GetRiskPolicySecurityOption2,
): string {
  return JSON.stringify(
    GetRiskPolicySecurityOption2$outboundSchema.parse(
      getRiskPolicySecurityOption2,
    ),
  );
}

/** @internal */
export type GetRiskPolicySecurity$Outbound = {
  Option1?: GetRiskPolicySecurityOption1$Outbound | undefined;
  Option2?: GetRiskPolicySecurityOption2$Outbound | undefined;
};

/** @internal */
export const GetRiskPolicySecurity$outboundSchema: z.ZodMiniType<
  GetRiskPolicySecurity$Outbound,
  GetRiskPolicySecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => GetRiskPolicySecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => GetRiskPolicySecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function getRiskPolicySecurityToJSON(
  getRiskPolicySecurity: GetRiskPolicySecurity,
): string {
  return JSON.stringify(
    GetRiskPolicySecurity$outboundSchema.parse(getRiskPolicySecurity),
  );
}

/** @internal */
export type GetRiskPolicyRequest$Outbound = {
  id: string;
  "Gram-Key"?: string | undefined;
  "Gram-Session"?: string | undefined;
  "Gram-Project"?: string | undefined;
};

/** @internal */
export const GetRiskPolicyRequest$outboundSchema: z.ZodMiniType<
  GetRiskPolicyRequest$Outbound,
  GetRiskPolicyRequest
> = z.pipe(
  z.object({
    id: z.string(),
    gramKey: z.optional(z.string()),
    gramSession: z.optional(z.string()),
    gramProject: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      gramKey: "Gram-Key",
      gramSession: "Gram-Session",
      gramProject: "Gram-Project",
    });
  }),
);

export function getRiskPolicyRequestToJSON(
  getRiskPolicyRequest: GetRiskPolicyRequest,
): string {
  return JSON.stringify(
    GetRiskPolicyRequest$outboundSchema.parse(getRiskPolicyRequest),
  );
}
